<template>
  <div
    class="mobile-submenu tw-fixed tw-left-0 tw-top-0 tw-z-50 tw-h-screen tw-w-screen tw-bg-white tw-px-2 tw-py-4 tw-transition-transform tw-duration-300"
    :class="{
      'tw-translate-x-full': !showSubmenu,
    }"
  >
    <div
      class="menu-item !tw-flex tw-items-center tw-gap-3 !tw-px-2"
      @click="showSubmenu = false"
    >
      <q-icon :name="toClassicIcon(chevronLeftIcon, 'solid')" size="12px" />
      <div>Terug</div>
    </div>

    <menu-link
      v-for="(item, key) in items"
      :key="key"
      :item="item"
      is-child
      class="!tw-px-2"
    />
  </div>
</template>

<script setup>
import MenuLink from "components/layout/MenuLink.vue";
import { chevronLeftIcon, toClassicIcon } from "common/defaultIcons";

defineProps({
  items: {
    type: Array,
    required: true,
  },
});

const showSubmenu = defineModel();
</script>
